<div v-if="organization" :ref="elementId">
	<div class="grid-2">
		<input-frame :id="`title-${elementId}`" v-model="organization.name"
			:label="$t('vm.root.user.organization.name.label')"
			:placeholder="$t('vm.root.user.organization.name.placeholder')"
			:error-test="hasNameError" :error-msg="$t('vm.root.user.organization.name.error-msg')"
			:title="$t('vm.root.user.organization.name.title')"/>

		<input-frame :id="`period-${elementId}`" v-model="organization.period"
			:label="$t('vm.root.user.organization.period.label')"
			:placeholder="$t('vm.root.user.organization.period.placeholder')"
			:title="$t('vm.root.user.organization.period.title')"/>

		<textarea-frame :id="`description-${elementId}`" class="grid-item-full" v-model="organization.description" rows="2"
			:label="$tc('vm.root.user.organization.description.label', messageLength)"
			:error-test="messageWarning" :error-msg="$t('vm.root.user.organization.description.msg-error')"
			:placeholder="$t('vm.root.user.organization.description.placeholder')"
			:title="$t('vm.root.user.organization.description.title')"/>
	</div>

	<div class="text-right">
		<delete-item class="btn--link-like text-danger" :can-delete="true"
			:title="$t('vm.root.user.organization.delete.title')"
			:delete-msg="$t('vm.root.user.organization.delete.msg')"
			:delete-action="deleteOrganization">
			<svg width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
				<use xlink:href="@Assets/svg/symbol-defs.svg#trash-alt"/>
			</svg>
			{{ $t('general.delete.text') }}
		</delete-item>
	</div>
</div>
